import { Pipe, PipeTransform } from '@angular/core';
import { statesIndiaKeyName } from '@mavles/shared';

@Pipe({
    name: 'indianStates',
    standalone: false
})
export class IndianStatesPipe implements PipeTransform {

  states = statesIndiaKeyName;

  transform(value: string): any {
    try {
      return this.states.filter(s=> s.key === value)[0].name;
    } catch (error) {
      console.error(error);
    }
    return value;
  }

}


